import { Box, CircularProgress } from '@mui/material';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { APIAuthClient } from '../../Api/ApiAuthClient';
import { useGateApi } from '../../Api/Hooks/useGateApi';
import { ToolApiGateClient } from '../../Api/Hooks/ApiServerHooks';


export interface IProtectedToolRouteProps {
    children: React.ReactNode;
    // route: string;
}

export default function ProtectedToolRoute(props: IProtectedToolRouteProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const { AuthorizedWithToken } = useGateApi(ToolApiGateClient);

    const [hasPermission, setHasPermission] = React.useState<boolean | undefined>(undefined);
    // const 
    React.useEffect(() => {
        new APIAuthClient().IsAuthed().then((r) => {
            if (r === true) {   
                setIsLoaded(true);
                // setLoggedIn(true);
                //@ts-ignore
                if (window.chrome.webview)
                    //@ts-ignore
                    window.chrome.webview.postMessage({ MessageType: 'start' });
            }
            else navigate('/login/' + encodeURIComponent(location.pathname.substring(1)));
        }).catch((err) => {
            console.log(err);
            navigate('/login/' + encodeURIComponent(location.pathname.substring(1)));
        });
    }, [location])

    React.useEffect(() => {
        let token = localStorage.getItem('token');
        if (!token) {
            setHasPermission(false);
            return;
        }
        AuthorizedWithToken(token).getPortalToolsPermissions().then((res) => {
            setHasPermission(res.hasIsoAnalyzer ?? false);

        }).catch(() => {
        });

    }, [location, AuthorizedWithToken])

    if (isLoaded && hasPermission === true)
        return (
            <Box>
                {props.children}
            </Box>
        );
    else if (isLoaded && hasPermission === false) {
        return (
            <Box sx={{ p: 2, width: '100%', textAlign: 'center', height: '100%', color: 'black' }}>
                Nemáte oprávnění k přístupu k tomuto nástroji.
            </Box>
        );
    }
    else return <CircularProgress />
}
